import BaseModelAPI from '../BaseModelAPI';

export default class PickingCardDetail extends BaseModelAPI {
	static entity = 'pickingcarddetail';
	static entityName = 'pickingcarddetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.pickingForDeliveryId = '';
			this.pickingForDelivery = {};
			this.pickingDetailId = '';
			this.pickingDetail = {};
			this.deliveryCardId = '';
			this.deliveryCard = {};
			this.controlCardId = '';
			this.controlCard = {};
			this.scanDate = '';
			this.scanById = '';
			this.scanBy = {};
			this.deliveryQty = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}